import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

// 获取浏览器语言设置
const getDefaultLocale = () => {
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang.toLowerCase().includes('zh')) {
    return 'zh'
  }
  return 'en'
}

// 从localStorage获取保存的语言设置，如果没有则使用浏览器默认语言
const savedLocale = localStorage.getItem('locale') || getDefaultLocale()

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    zh,
    en
  }
})

// 保存语言设置到localStorage
export const setLocale = (locale) => {
  i18n.locale = locale
  localStorage.setItem('locale', locale)
}

export default i18n